<template>
  <v-container fluid>
    <PaginationController
      v-model="rechargeRequests"
      getDataActionName="getChainRechargeRequestsPagination"
      :historyLimit="historyLimit"
      :haveStartDate="true"
      isPagination
    >
      <template v-slot:dataTable>
        <v-data-table
          :headers="headers"
          :items="rechargeRequests"
          hide-actions
          disable-initial-sort
          item-key="_key"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">
              <v-layout column>
                <v-flex>{{ getRequestId(props.item) }}</v-flex>
                <!-- <v-flex
                  v-if="props.item.chainRechargeRequestId && props.item.chainRechargeRequestId !== getRequestId(props.item)"
                  class="caption grey--text text--darken-1"
                >
                  {{ props.item.chainRechargeRequestId }}
                </v-flex> -->
              </v-layout>
            </td>
            <td class="text-xs-left">
              <v-layout column>
                <v-flex>{{ props.item.clientName || '---' }}</v-flex>
                <v-flex class="caption grey--text text--darken-1">
                  {{ props.item.orgKey || props.item.clientKey || '---' }}
                </v-flex>
              </v-layout>
            </td>
            <td class="text-xs-left">
              {{ formatAmount(props.item) }}
            </td>
            <td class="text-xs-left">
              {{ props.item.chain || '---' }}
            </td>
            <td class="text-xs-left" style="word-break: break-word; max-width: 220px;">
              {{ props.item.depositAddress || '---' }}
            </td>
            <td class="text-xs-left" style="word-break: break-word; max-width: 240px;">
              <v-layout column>
                <v-flex>{{ getTxHash(props.item) }}</v-flex>
              </v-layout>
            </td>
            <td class="text-xs-left">
              {{ props.item.status || '---' }}
            </td>
            <td class="text-xs-left">
              {{ props.item.createTime ? toTimestampString(props.item.createTime) : '---' }}
            </td>
            <td class="text-xs-left">
              {{ props.item.lastModifiedTime ? toTimestampString(props.item.lastModifiedTime) : '---' }}
            </td>
          </template>
        </v-data-table>
      </template>
    </PaginationController>
  </v-container>
</template>

<script>
import PaginationController from './PaginationController'
import { toTimestampString } from '../utils/tools'

export default {
  name: 'ChainRechargeRequests',
  components: {
    PaginationController
  },
  data () {
    return {
      historyLimit: 25,
      rechargeRequests: [],
      headers: [{
        text: this.$t('requestId'),
        value: 'requestId',
        align: 'left',
        sortable: false
      }, {
        text: this.$t('clientName'),
        value: 'clientName',
        align: 'left',
        sortable: false
      }, {
        text: this.$t('amount'),
        value: 'expectedAmount',
        align: 'left',
        sortable: false
      }, {
        text: this.$t('network'),
        value: 'network',
        align: 'left',
        sortable: false
      }, {
        text: this.$t('address'),
        value: 'depositAddress',
        align: 'left',
        sortable: false
      }, {
        text: this.$t('txHash'),
        value: 'txHash',
        align: 'left',
        sortable: false
      }, {
        text: this.$t('status'),
        value: 'status',
        align: 'left',
        sortable: false
      }, {
        text: this.$t('createTime'),
        value: 'createTime',
        align: 'left',
        sortable: false
      }, {
        text: this.$t('lastModifiedTime'),
        value: 'lastModifiedTime',
        align: 'left',
        sortable: false
      }]
    }
  },
  methods: {
    toTimestampString,
    getRequestId (item) {
      return item.requestId || item.chainRechargeRequestId || item._key || '---'
    },
    formatAmount (item) {
      if (typeof item.expectedAmount === 'number') {
        return `$${item.expectedAmount.toLocaleString()}`
      }
      return item.expectedAmount ? `$${item.expectedAmount}` : '---'
    },
    getTxHash (item) {
      return item.matchedTxHash || item.detectedTxHash || item.systemTransactionId || '---'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChainRechargeRequests.vue